import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NSEquipmentCellModule, NSGridActionCellModule, NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { DiversionsReviewDetailsComponent } from '@ruby/modules/diversions/submodules/review-details/components/diversions-review-details/diversions-review-details.component';
import { DiversionsReviewDetailsContainer } from '@ruby/modules/diversions/submodules/review-details/containers/diversions-review-details/diversions-review-details.container';
import { RequestNumberCellContainer } from '@ruby/modules/diversions/submodules/review-details/containers/request-number-cell.container';
import { WaybillCellContainer } from '@ruby/modules/diversions/submodules/review-details/containers/waybill-cell.container';
import { DiversionsReviewDetailsRoutingModule } from '@ruby/modules/diversions/submodules/review-details/diversions-review-details-routing.module';
import { DiversionsRejectModule } from '@ruby/shared/dialogs/diversions/diversions-reject/diversions-reject.module';
import { DiversionsWaybilllPreviewModule } from '@ruby/shared/dialogs/diversions/waybill-preview/waybill-preview.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    DiversionsReviewDetailsComponent,
    DiversionsReviewDetailsContainer,
    WaybillCellContainer,
    RequestNumberCellContainer
  ],
  imports: [
    CommonModule,
    DiversionsReviewDetailsRoutingModule,
    NSGridActionCellModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    NSEquipmentCellModule,
    MatDialogModule,
    MatTableModule,
    MatToolbarModule,
    NSSkeletonModule,
    DiversionsWaybilllPreviewModule,
    DiversionsRejectModule
  ],
  exports: [
    DiversionsReviewDetailsContainer
  ],
  providers: []
})
export class DiversionsReviewDetailsModule {}
